export const BOARD_TYPES = [
  { key: "initiatives", label: "Initiatives", type: "INITIATIVE" },
  { key: "design", label: "Design", type: "DESIGN" },
  { key: "frontend", label: "Frontend", type: "FRONTEND" },
  { key: "backend", label: "Backend", type: "BACKEND" },
  { key: "bugs", label: "Bugs", type: "BUG" },
];

export const STATUSES = ["BACKLOG", "IN_PROGRESS", "REVIEW", "DONE"];

export const STATUS_LABELS = {
  BACKLOG: "Backlog",
  IN_PROGRESS: "In Progress",
  REVIEW: "Review",
  DONE: "Done",
};

export const STATUS_COLORS = {
  BACKLOG: { bg: "#F3F4F6", text: "#4B5563", border: "#E5E7EB" },
  IN_PROGRESS: { bg: "#FEF3C7", text: "#D97706", border: "#FDE68A" },
  REVIEW: { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE" },
  DONE: { bg: "#D1FAE5", text: "#059669", border: "#A7F3D0" },
};

export const PRIORITIES = ["CRITICAL", "HIGH", "MEDIUM", "LOW"];

export const PRIORITY_COLORS = {
  CRITICAL: { bg: "#FEE2E2", text: "#DC2626", border: "#FECACA" },
  HIGH: { bg: "#FEF3C7", text: "#D97706", border: "#FDE68A" },
  MEDIUM: { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE" },
  LOW: { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" },
};

export const ISSUE_TYPE_CONFIG = {
  INITIATIVE: { bg: "#EDE9FE", text: "#7C3AED", label: "Initiative" },
  DESIGN: { bg: "#FCE7F3", text: "#DB2777", label: "Design" },
  FRONTEND: { bg: "#DBEAFE", text: "#2563EB", label: "Frontend" },
  BACKEND: { bg: "#E0F2FE", text: "#0284C7", label: "Backend" },
  QA: { bg: "#FEF3C7", text: "#D97706", label: "QA" },
  BUG: { bg: "#FEE2E2", text: "#DC2626", label: "Bug" },
};

export const ISSUE_TYPES = ["INITIATIVE", "DESIGN", "FRONTEND", "BACKEND", "QA", "BUG"];

export const ENVIRONMENTS = ["EPH", "DEV", "PROD"];

export const ENV_LABELS = {
  EPH: "Ephemeral",
  DEV: "Development",
  PROD: "Production",
};

export const ENV_COLORS = {
  EPH: { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" },
  DEV: { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE" },
  PROD: { bg: "#FEE2E2", text: "#DC2626", border: "#FECACA" },
};

// Returns true if dateStr is strictly in the past (before today)
export const isPastDate = (dateStr) => {
  if (!dateStr) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);
  return d < today;
};
